<template lang="pug">
.dimensions-field-widget
  div
    a.doc-link.doc-link-pdf(:href="docLink", target="_blank", v-text="frText.abTest.prd14.variationB.fields.dimension.docLink")
  .double-dimension-field-container
    .double-dimension-field-item
      Dimension(:field="hookedWidthField", :mint="mint", :fieldRef='hookedWidthField.chKey', :cc_value="getCcWidthValue", v-on:field-changed="fieldHasChanged", :uom="uom")
    .double-dimension-field-item
      Dimension(:field="hookedHeightField", :mint="mint", :fieldRef='hookedHeightField.chKey', :cc_value="getCcHeightValue", v-on:field-changed="fieldHasChanged", :uom="uom")
</template>
<script>
import Dimension from './Dimension'
import fr from '../../../config/translationFr'
export default {
  name: 'dimensions-field-widget',
  props: {
    widthField: {
      type: Object,
      default: { label: 'width', minValue: 0, maxValue: 100, tooltip: '' }
    },
    heightField: {
      type: Object,
      default: { label: 'height', minValue: 0, maxValue: 100, tooltip: '' }
    },
    docLink: {
      type: String,
      default: ''
    },
    cc: {
      type: Object,
      default: () => ({
        config_1: {
          prefilled_values: {
            widthFieldRef: 1000,
            heightFieldRef: 1000
          }
        }
      })
    },
    uom: {
      type: String,
      default: 'cm'
    },
    widthFieldRef: {
      type: String,
      default: ''
    },
    heightFieldRef: {
      type: String,
      default: ''
    },
    widthFieldLabel: {
      type: String,
      default: ''
    },
    widthFieldSubtitle: {
      type: String,
      default: ''
    },
    heightFieldLabel: {
      type: String,
      default: ''
    },
    heightFieldSubtitle: {
      type: String,
      default: ''
    },
    fieldHasChanged: {
      type: Function,
      default: function () {}
    },
    mint: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
    Dimension
  },
  computed: {
    frText: () => fr,
    getCcWidthValue: function () {
      return this.cc.config_1.prefilled_values[this.widthFieldRef]
    },
    getCcHeightValue: function () {
      return this.cc.config_1.prefilled_values[this.heightFieldRef]
    },
    hookedWidthField: function () {
      const field = this.widthField
      field.label = this.widthFieldLabel
      field.subtitle = this.widthFieldSubtitle
      return field
    },
    hookedHeightField: function () {
      const field = this.heightField
      field.label = this.heightFieldLabel
      field.subtitle = this.heightFieldSubtitle
      return field
    }
  },
  methods: {
  },
  watch: {
    cc: function (newValue, oldValue) {
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// DimensionsFieldWidget.vue?4f6b662e